module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="row">\n    <section class="col-xs-4">\n        <p class="intro">With Creator\'s ability to integrate your favorite custom fonts, you can upload your font files right from your computer and start using them in your Creator Experiences right away.</p>\n        <p>Creator currently supports Web Open (WOFF) font format. You will only see the 20 most recently uploaded fonts in the font selection dropdown by default, but you are able to use any of your uploaded fonts by searching.</p>\n        <div class="notification-box">\n            <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">Font Upload Permissions</span>\n            <p>Make sure your font provider allows integration with third party tools before uploading.</p>\n        </div>\n    </section>\n    <section class="col-xs-4">\n        <h4>Upload</h4>\n        <div class="font-drop-area"></div>\n    </section>\n    <section class="col-xs-4">\n        <h4>Your Custom Fonts</h4>\n        <div class="font-collection-region"></div>\n    </section>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/fonts/ManageCustomFontsIntegrationView.tpl
// module id = 3131
// module chunks = 0